import SiafLiteApiRepository from "../../external/siafLiteApi";

class ContasPagarObservacoesService {
  constructor() {
    this.urlBase = "/financeiro/contas-pagar-observacoes";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }
}

export default ContasPagarObservacoesService;
